'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import { PENDING } from 'marketplace-ui-reviews/constants/UnreviewableReason';
import { getInAppReviewLink } from '../../utils/urls';
const I18N_BASE = 'ecosystem-marketplace-solutions-ui.profile.reviews';

const WriteReviewButton = ({
  isPreview,
  isPublicApp,
  profileListing,
  reviewButtonRef,
  reviewPending,
  setWizardOpen,
  size
}) => {
  const {
    reviewability,
    slug
  } = profileListing;
  const isReviewable = isPublicApp || reviewability.isReviewable() && !reviewPending;
  const reason = reviewPending ? PENDING : reviewability.getUnreviewableReason();
  let buttonProps;

  if (isPreview) {
    buttonProps = {};
  } else {
    if (isPublicApp) {
      buttonProps = {
        href: getInAppReviewLink(slug)
      };
    } else {
      buttonProps = {
        onClick: () => setWizardOpen(true)
      };
    }
  }

  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${I18N_BASE}.unreviewable.${reason}`
    }),
    disabled: isReviewable,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      disabled: !isReviewable,
      use: "tertiary",
      size: size,
      tabIndex: -1
    }, buttonProps, {
      children: /*#__PURE__*/_jsx("div", {
        tabIndex: 0,
        ref: reviewButtonRef,
        role: "button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_BASE}.write.button`
        })
      })
    }))
  });
};

WriteReviewButton.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  isPublicApp: PropTypes.bool.isRequired,
  profileListing: PropTypes.instanceOf(ProfileListing),
  reviewButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  reviewPending: PropTypes.bool.isRequired,
  setWizardOpen: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired
};
WriteReviewButton.defaultProps = {
  size: 'sm'
};
export default WriteReviewButton;